module.exports = __webpack_public_path__ + "img/textarea.d46a50f9.svg";